export const AdminNotificationController = {
    index(): void {},
    recent(): void {},
    unreadCount(): void {},
    markAllRead(): void {},
    markRead(): void {},
};
